import React from "react";
import "../supplierAndManufacturers.scss";
import { HGHighlightText } from "../../../App/App";
import { TechnologySpendColorList } from "../../../../Utils/CommonFunctions";
import PlusIcon from "../../../icons/plus.icon";

const TableBody = ({
  isView = false,
  data = [],
  dataToMap = [],
  clientId = 0,
  searchString = "",
  onItemClick = () => { },
  onAddClick = () => { },
}) => {
  return (
    <div className="tableData">
      {
        dataToMap?.map((dataItem) => (
          <DataItem
            showColumns={data?.MSPClientSortVisibility_List}
            dataItem={dataItem?.MSPClientColumnData_List}
            searchString={searchString}
            onItemClick={() => { onItemClick(dataItem?.objId_Customer, clientId); }}
          />
        ))
      }
      {!isView && (
        <div className="d-flex align-items-center pointer py-2 px-3" onClick={onAddClick}>
          <PlusIcon fill="#008FD4" width={8} height={8} />
          <span className="f-12 line-height-22 ml-1 f-blue">Add New</span>
        </div>
      )}
    </div>
  );
};

export default TableBody;

const DataItem = ({
  showColumns = [],
  dataItem = {},
  searchString = '',
  onItemClick = () => { },
}) => {
  const columns = [
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Company"),
      Component: (<CompanyItem name={(dataItem?.find(obj => obj?.FieldName === "Company"))?.FieldValue} search={searchString} icon={dataItem[0]?.Icon} />)
    },
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Type"),
      Component: (<div className="d-flex align-items-center">
        {
          (dataItem?.find(obj => obj?.FieldName === "Type"))?.FieldName_List?.map((item, suppliersAndManufacturersTable) => (
            <div>{suppliersAndManufacturersTable !== 0 ? ', ' : ''}{item?.OwnerName}</div>
          ))
        }
      </div>)
    },
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Status"),
      Component: (<StatusItem isActive={(dataItem?.find(obj => obj?.FieldName === "Status"))?.FieldValue === 'Active'} />)
    },
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Categories"),
      Component: (<CategoryOrSubcategoryItem name={(dataItem?.find(obj => obj?.FieldName === "Categories"))?.FieldValue} color={(dataItem?.find(obj => obj?.FieldName === "Categories"))?.Icon} />)
    },
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Subcategories"),
      Component: (<div className="d-flex align-items-center">
        {
          (dataItem?.find(obj => obj?.FieldName === "Subcategories"))?.FieldName_List?.map((item) => (
            <div className="mr-2">
              <CategoryOrSubcategoryItem name={item?.OwnerName} color={item?.OwnerLogo} />
            </div>
          ))
        }
      </div>)
    },
    {
      header: showColumns?.find(obj => obj?.FieldKey === "Spend"),
      Component: (<div>{(dataItem?.find(obj => obj?.FieldName === "Spend"))?.FieldValue}</div>)
    }
  ];

  return (
    <div className="dataItem suppliersAndManufacturersTable pointer bg-hover-grey" onClick={onItemClick}>
      {
        (columns?.filter((column) => column?.header?.Visibility))?.sort((a, b) => a?.header?.SortOrder - b?.header?.SortOrder)?.map((column, index) => {
          return (
            column?.Component
          )
        })
      }
    </div>
  )
}

const CompanyItem = ({ name = '', search = '', icon }) => (
  <div className="companyInfo">
    <img
      src={icon ?? '/images/settings-v2/supplier-manufacturer-default-icon.svg'}
      width={20} height={20}
      alt="company logo"
      className="rounded-full mr-2 borderWhite"
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        currentTarget.src = '/images/settings-v2/supplier-manufacturer-default-icon.svg';
      }}
    />
    <span dangerouslySetInnerHTML={{ __html: HGHighlightText(name, search) }} />
  </div>
)

const StatusItem = ({ isActive = false }) => (
  <div className={`statusInfo ${isActive ? 'active' : ''}`}>{isActive ? 'Active' : 'Inactive'}</div>
)

export const CategoryOrSubcategoryItem = ({
  name = '',
  color = '',
  isLast = false,
  onCrossClick
}) => (
  <div className={`categoryItem mt-1 ${isLast ? '' : 'mr-2'}`}>
    {color && <div style={{ width: "8px", height: "8px", background: getColorHex(color) }} alt="" className="mr-2 rounded-full" />}
    <div>{name}</div>
    {
      onCrossClick && <span className="cursor-pointer ml-1" style={{ marginBottom: '2px' }} onClick={onCrossClick}>
        <img src="/images/attack-surface/cross-icon.svg" alt="" />
      </span>
    }
  </div>
)

export function getColorHex(color = '#0C0D11') {
  if (color?.includes("#")) {
    return color;
  } else {
    return TechnologySpendColorList.find(obj => obj.ColorName === color)?.ColorCode;
  }
}